import { SlideAction, SlideHideConditionType, SlideHidePageCondition, TutorialSection, TutorialSlide } from "../../tutorial.models";

export const SCHEDULE_SETTINGS_SLIDES: TutorialSlide[] = [
    {
        key: 'Welcome-Schedule',
        title: 'Schedule Settings! 👋',
        messages: [{ text: "Let's be real: managing a medical practice is both unique and complex. That's why we've designed our scheduling system specifically with this in mind. With our customizable schedule/calendar, you'll have a clear view of your workload at a glance and can instantly link to relevant patient files whenever you need them." }],
        actions: [
            {
                text: 'Get Started',
                color: 'primary',
                actionName: SlideAction.SHOW_NEXT_SLIDE,
            },
        ],
        position: { x: 150, y: 450 },
        hideDoNotShowAgain: true,
        hideConditions: [
            { condition: SlideHidePageCondition.NOT_ADMIN_USER, type: SlideHideConditionType.OR },
            { condition: SlideHidePageCondition.DIALOG_SLIDE_HIDDEN, type: SlideHideConditionType.OR },
            { condition: SlideHidePageCondition.SCHEDULE_COMPLETED, type: SlideHideConditionType.AND },
            { condition: SlideHidePageCondition.APPOINTMENT_EDITED, type: SlideHideConditionType.AND },
        ],
    },
    {
        key: 'Add-Time-Slots',
        title: 'Set Time Slots',
        messages: [
            { text: "Set up your time slot settings to the length you prefer. If your appointment types have different time durations, go with the shortest option. For example, if new patient appointments take an hour but follow-ups only last 15 minutes, set it to 15 minutes." },
        ],
        expansionTarget: 'TIME_SLOT',
        highlightTarget: 'TIME_SLOT',
        forceOpenTarget: true,
        previousButton: SlideAction.SHOW_PREV_SLIDE,
        actions: [
            {
                text: 'Next',
                color: 'primary',
                actionName: SlideAction.SHOW_NEXT_SLIDE,
            },
        ],
        position: { x: 150, y: 450 },
        hideConditions: [
            { condition: SlideHidePageCondition.NOT_PHYSICIAN, type: SlideHideConditionType.OR },
            { condition: SlideHidePageCondition.DIALOG_SLIDE_HIDDEN, type: SlideHideConditionType.OR },
            { condition: SlideHidePageCondition.SCHEDULE_COMPLETED, type: SlideHideConditionType.OR },
        ],
    },
    // {
    //     key: 'Add-Time',
    //     title: 'Set Time Slots',
    //     messages: [
    //         { text: "Using the MedicAI Calendar to schedule appointments and procedures makes life so much easier for doctors, keeping them updated on their commitments at a quick glance. Plus, since patient files are linked directly to the calendar, your doctor can pull up patient info with just a click.  For example, if you have an outpatient consult day lined up with 15 patients, just make sure you've added everyone to the schedule. Then, on the clinic date, your doctor can click through each patient's appointment one by one. This lets them access the patient's file and start recording notes or generating AI summaries without the hassle of flipping through paper files. It's efficient and smooth sailing!" },
    //     ],
    //     expansionTarget: 'TIME_SLOT',
    //     highlightTarget: 'TIME_SLOT',
    //     forceOpenTarget: true,
    //     actions: [
    //         {
    //             text: 'Next',
    //             color: 'primary',
    //             actionName: SlideAction.SHOW_NEXT_SLIDE,
    //         },
    //     ],
    //     position: { x: 150, y: 450 },
    //     hideConditions: [
    //         { condition: SlideHidePageCondition.IS_PHYSICIAN, type: SlideHideConditionType.OR },
    //         { condition: SlideHidePageCondition.DIALOG_SLIDE_HIDDEN, type: SlideHideConditionType.OR },
    //         { condition: SlideHidePageCondition.SCHEDULE_COMPLETED, type: SlideHideConditionType.OR },
    //     ],
    // },
    // {
    //     key: 'Consult-Day',
    //     title: 'Consult Day',
    //     keepDialogOpen: true,
    //     messages: [
    //         { text: "On your consult day, every patient on your schedule will have a status to keep things organized. They'll start off in grey, meaning they haven't arrived at the clinic yet. Once they show up, just tick “patient arrived,” and their status will change to orange, indicating they're waiting to be seen. This way, the doctor knows they're there and waiting without needing to step into the consulting room or send a message.  When a doctor goes into the consult room and begins seeing the patient, their status will switch to purple as soon as the doctor starts recording the consult. Once the consult is finished and recording stops, the status will turn green, showing that the patient has been seen. For the doctors, green also means their notes are complete.  Plus, patients who don't make it to their appointments will stay in grey, making it easy to spot who hasn't arrived yet or did not attend at all." },
    //     ],
    //     expansionTarget: 'TIME_SLOT',
    //     highlightTarget: 'TIME_SLOT',
    //     forceOpenTarget: true,
    //     actions: [
    //         {
    //             text: 'Next',
    //             color: 'primary',
    //             actionName: SlideAction.SHOW_NEXT_SLIDE,
    //         },
    //     ],
    //     position: { x: 150, y: 450 },
    //     hideConditions: [
    //         { condition: SlideHidePageCondition.NOT_PHYSICIAN, type: SlideHideConditionType.OR },
    //         { condition: SlideHidePageCondition.DIALOG_SLIDE_HIDDEN, type: SlideHideConditionType.OR },
    //         { condition: SlideHidePageCondition.SCHEDULE_COMPLETED, type: SlideHideConditionType.OR },
    //     ],
    // },

    {
        key: 'Add-appTypes',
        title: 'Appointment Types',
        messages: [
            { text: "To customize existing appointment types, just double-click on them (or tap and hold on a touch screen), and if you want to add new ones, simply hit the \"+\" button. The next slide will cover this in detail." },
        ],
        expansionTarget: 'APPOINTMENT_TYPE',
        highlightTarget: 'APPOINTMENT_TYPE',
        //forceOpenTarget: true,
        actions: [
            {
                text: 'Next',
                color: 'primary',
                actionName: SlideAction.SHOW_NEXT_SLIDE,
            },
        ],
        position: { x: 150, y: 450 },
        hideConditions: [
            { condition: SlideHidePageCondition.NOT_ADMIN_USER, type: SlideHideConditionType.OR },
            { condition: SlideHidePageCondition.DIALOG_SLIDE_HIDDEN, type: SlideHideConditionType.OR },
            { condition: SlideHidePageCondition.APPOINTMENT_EDITED, type: SlideHideConditionType.OR },
        ],
    },
    {
        key: 'Add-appType-Settings',
        // title: 'Appointment Type Settings',
        messages: [
            { text: "Click on the video above to learn how to manage your appointment types!" },
        ],
        videoUrl: 'https://www.youtube.com/watch?v=kg42H2ZpgFY',
        thumbnailUrl: 'assets/appointment-types-thumbnail.png',
        highlightTarget: 'APPOINTMENT_TYPE',
        //forceOpenTarget: true,
        //keepDialogOpen: true,
        actions: [
            {
                text: 'Next',
                color: 'primary',
                actionName: SlideAction.SHOW_NEXT_SLIDE,
            },
        ],
        position: { x: 150, y: 450 },
        hideConditions: [
            { condition: SlideHidePageCondition.NOT_ADMIN_USER, type: SlideHideConditionType.OR },
            { condition: SlideHidePageCondition.DIALOG_SLIDE_HIDDEN, type: SlideHideConditionType.OR },
            { condition: SlideHidePageCondition.APPOINTMENT_EDITED, type: SlideHideConditionType.OR },
        ],
    },
    {
        key: 'Schedule-Finish',
        title: 'Completed Schedule Settings!',
        messages: [
            { text: "You are 55% done!" },
        ],
        highlightTarget: 'CLEAR',
        hasBackdrop: true,
        //position: { vertical: 'center', horizontal: 'center' },
        dimensions: { width: '450px' },
        actions: [
            {
                text: 'Carry on - Recommended',
                color: 'primary',
                actionName: SlideAction.START_CONSENT_TUTORIAL,
            },
            {
                text: 'Continue Later',
                color: 'warn',
                actionName: SlideAction.CLOSE_TUTORIAL,
                suffixText: 'Continue Later'
            },

        ],
        position: { x: 700, y: 350 },
        hideDoNotShowAgain: true,
        progressBar: 55,
        hideConditions: [
            { condition: SlideHidePageCondition.NOT_ADMIN_USER, type: SlideHideConditionType.OR },
            { condition: SlideHidePageCondition.DIALOG_SLIDE_HIDDEN, type: SlideHideConditionType.OR },
            { condition: SlideHidePageCondition.SCHEDULE_COMPLETED, type: SlideHideConditionType.AND },
            { condition: SlideHidePageCondition.APPOINTMENT_EDITED, type: SlideHideConditionType.AND },
        ],
    },
];